/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![ImageFileIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABnElEQVR4nN2Vv0vDUBDHi78o6p+gmyIUV+eo0Kl5dy/Cy50oBB3yD7i51LHg7uheEQQF9Z9wc9fFIljFik7FH7w0qTFN0qR10YODJC/3/dy9d7kUCv/KEGkWJB0LyS8g+TPJBVIziAGwtzKLC+THNGEIeRfQua/1BejMI1k2BNK7740+gP6Q8LYIyTeGYYwJoea0u647Dki3YYBSaroTR3eZID8yRKr3rCPVw+8g0rIfV4tUvpcOQD43HKcYXTccpwhIF99V0ql+rpSa0JBIJdsDAYSky0i2u6n7nm+L+Ci2o5DPAOyV4EwyAfQh64OtrK3Pa4875KzfSXwFntN90Kb6Oqt4tI1TAAmOfCUkuSB5HyS3fxlA1+Xy5lQQIyQ7wwI+QPKbL/4KoErROCH5cEAAPVQse1EpNQrIBzrbuOYwTXNSV5YX0BYWrwZr1Wp1JE68Gwuq5FWYFSCQd9IE40yP7VRAeNiZlr1UyGkAaiGU4HPvC5JO8vY6JLZy7yTwM6CnYcUFUtOyNmaSf5nezKFWfnFq6cwTxf+sfQF+XyWyiW5p0gAAAABJRU5ErkJggg==)
 */
export const ImageFileIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        fillRule="evenodd"
        d="M6 22h12a4 4 0 0 0 4-4v-7.5a.5.5 0 0 0-.5-.5H19a5 5 0 0 1-5-5V2.5a.5.5 0 0 0-.5-.5H6a4 4 0 0 0-4 4v12a4 4 0 0 0 4 4Zm9.35-8.87 3.5 4.67c.37.5.02 1.2-.6 1.2H5.81a.75.75 0 0 1-.59-1.22l1.86-2.32a1.5 1.5 0 0 1 2.34 0l.5.64 2.23-2.97a2 2 0 0 1 3.2 0ZM10.2 5.98c.23-.91-.88-1.55-1.55-.9a.93.93 0 0 1-1.3 0c-.67-.65-1.78-.01-1.55.9a.93.93 0 0 1-.65 1.12c-.9.26-.9 1.54 0 1.8.48.14.77.63.65 1.12-.23.91.88 1.55 1.55.9a.93.93 0 0 1 1.3 0c.67.65 1.78.01 1.55-.9a.93.93 0 0 1 .65-1.12c.9-.26.9-1.54 0-1.8a.93.93 0 0 1-.65-1.12Z"
        clipRule="evenodd"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M21.66 8c.03 0 .05-.03.04-.06a3 3 0 0 0-.58-.82l-4.24-4.24a3 3 0 0 0-.82-.58.04.04 0 0 0-.06.04V5a3 3 0 0 0 3 3h2.66Z"
        className={colorClass}
      />
    </svg>
  );
};
